<template>
  <v-container grid-list-xl>
    <v-layout justify-center row wrap>
      <v-flex xs12>
        <w-main-title
          class="pb-0"
          title="Promociones"
          :breadcrumbs="breadcrumbs"
        ></w-main-title>
      </v-flex>
      <v-flex xs12 class="text-right">
        <v-btn class="secondary" small outlined @click="newOffer = true">
          Nueva Promoción
          <v-icon right size="14">fas fa-calculator</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4 md3>
        <v-text-field
          clearable
          prepend-icon="fas fa-search"
          v-model="filterTerm"
          label="Búsqueda"
          hint="Servicio, Titulo o Descripción"
        ></v-text-field>
        <date-picker label="Fecha Desde" ref="from"></date-picker>
        <date-picker label="Fecha Hasta" ref="to"></date-picker>
        <v-select
          label="Estado de Publicación"
          :items="statuses"
          item-text="text"
          item-value="value"
          v-model="status"
          clearable
          prepend-icon="fas fa-toggle-on"
        ></v-select>
        <v-btn
          block
          outlined
          color="primary"
          small
          @click="getOffers"
          :loading="consulting"
          >Aplicar Filtro</v-btn
        >
      </v-flex>
      <v-flex xs12 sm8 md9>
        <v-layout row wrap v-if="loadingQuotationFromApi">
          <v-flex xs12 class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <template>
            <v-flex xs12 v-if="offers.length === 0">
              <h3 class="font-weight-light text-center mt-4">
                No hay promociones creadas
              </h3>
            </v-flex>
          </template>
          <template>
            <v-flex xs12 sm6 v-for="item in offers" :key="item.id">
              <v-card style="position:relative;">
                <offer-status :active="item.active"></offer-status>
                <v-img :src="item.image" aspect-ratio="2.5"></v-img>
                <span class="discount">
                  <h2>-{{ item.discount }}%</h2>
                </span>
                <v-card-text>
                  <h5 class="font-weight-light">
                    {{ item.service }} | {{ item.serviceItem }}
                  </h5>
                  <h2 class="font-weight-light primary--text">
                    {{ item.title }}
                  </h2>
                  <p class="mb-0">
                    <small class="primary--text">Creada el</small><br />{{
                      $moment(item.created).format('ddd DD MMM YYYY | HH:mm')
                    }}
                  </p>
                </v-card-text>
                <v-btn
                  block
                  depressed
                  small
                  color="grey lighten-3"
                  light
                  @click="viewSingleOffer(item)"
                  >ver detalles</v-btn
                >
              </v-card>
            </v-flex>
            <v-flex xs12>
              <item-counter
                :length="offers.length"
                :total="totalItems"
              ></item-counter>
              <next-page-btn
                :loading="consulting"
                v-if="nextPageUrl"
                :nextFn="getOffersNextPage"
              ></next-page-btn>
            </v-flex>
          </template>
        </v-layout>
        <!-- <pre>{{offers}}</pre> -->
      </v-flex>
    </v-layout>
    <v-dialog v-model="newOffer" max-width="800px" persistent >
      <modal-create-offer
        :services="services"
        @close="newOffer = false"
        @addedItem="totalItems++"
      ></modal-create-offer>
    </v-dialog>
    <v-dialog v-model="viewDetails" max-width="400px" >
      <view-single-offer
        ref="viewDetails"
        :item="singleOffer"
        @close="newOffer = false"
      ></view-single-offer>
    </v-dialog>
  </v-container>
</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'
import { queryFilterBuilder } from '@/utils/Shared'

export default {
  components: {
    WMainTitle: () => import('@/components/common/WMainTitle'),
    ModalCreateOffer: () =>
      import('@/components/providers/offers/ModalCreateOffer'),
    ViewSingleOffer: () =>
      import('@/components/providers/offers/ViewSingleOffer'),
    OfferStatus: () => import('@/components/providers/offers/OfferStatus'),
    DatePicker: () => import('@/components/common/DatePicker'),
    NextPageBtn: () => import('@/components/common/NextPageBtn'),
    ItemCounter: () => import('@/components/common/ItemCounter')
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Promociones',
          disabled: true,
          href: ''
        }
      ],
      newOffer: false,
      services: [],
      page: 1,
      totalPages: 0,
      totalItems: 0,
      nextPageUrl: null,
      viewDetails: false,
      singleOffer: null,
      loadingQuotationFromApi: false,
      filterTerm: '',
      status: null,
      statuses: [{ text: 'Activa', value: 1 }, { text: 'Inactiva', value: 0 }],
      consulting: false
    }
  },
  watch: {
    viewDetails: function(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.viewDetails.updateRemaining()
        }, 100)
      }
    }
  },
  async mounted() {
    this.loadingQuotationFromApi = true
    this.services = await this.$store.dispatch(
      'quotations/loadProviderServices'
    )
    await this.getOffers()
    this.loadingQuotationFromApi = false
  },
  computed: {
    offers() {
      return this.$store.getters['offers/allOffers']
    }
  },
  methods: {
    applyFilter() {
      const filters = {
        term: this.filterTerm,
        start_date: this.$refs.from.date,
        end_date: this.$refs.to.date,
        active: this.status
      }
      return queryFilterBuilder(filters) // ok, query
    },
    async getOffers() {
      this.consulting = true
      const query = this.applyFilter()
      const payload = query.ok ? { query: query.query } : { query: '' }
      const offers = await this.$store.dispatch('offers/getOffers', payload)
      this.loadData(offers)
      this.consulting = false
    },
    async getOffersNextPage() {
      this.consulting = true
      const offers = await this.$store.dispatch('offers/getOffers', {
        nextPage: true
      })
      this.loadData(offers)
      this.consulting = false
    },
    loadData(payload) {
      this.page = payload.current_page
      this.totalPages = payload.last_page
      this.nextPageUrl = payload.next_page_url
      this.totalItems = payload.total_items
    },
    viewSingleOffer(item) {
      this.singleOffer = item
      this.viewDetails = true
    }
  }
}
</script>
<style scoped>
.discount {
  background-color: red;
  color: white;
  display: inline-block;
  padding: 4px 10px;
  position: absolute;
  top: 30px;
  right: 0;
}
.discount h3 {
  font-weight: 900;
}
</style>
